import React, { useEffect, useState } from "react";
import { empresasMaisCitadas } from "../services/api";
import { teclaAtiva } from "../utils/teclaAtiva";

export default function MostComplainedCompanies({ onSelect }) {
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    empresasMaisCitadas().then(setCompanies).catch(() => setCompanies([]));
  }, []);

  if (!companies.length) return null;

  const max = Math.max(...companies.map((c) => c.total), 1);

  return (
    <div className="rounded-2xl border border-gray-200 bg-white p-4 shadow-sm">
      <h4 className="text-base font-semibold text-gray-900">Mais reclamadas</h4>
      <p className="text-xs text-gray-400 mt-0.5">Empresas com mais relatos registrados. O número à esquerda é a posição no ranking.</p>

      <ul className="mt-4 space-y-3">
        {companies.map((c, idx) => (
          <li
            key={c.id}
            onClick={() => onSelect?.(c.id)}
            {...teclaAtiva(() => onSelect?.(c.id))}
            aria-label={`Ver reputação de ${c.nome}`}
            className="cursor-pointer rounded-xl border border-gray-100 p-3 hover:border-primary focus:outline-none focus:ring-2 focus:ring-primary"
          >
            <div className="flex items-center gap-3">
              <span className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-orange-100 text-xs font-bold text-orange-700" title={`Posição ${idx + 1} no ranking`}>{idx + 1}</span>
              <span className="font-medium text-gray-900">{c.nome}</span>
              {c.porte && <span className="text-[11px] rounded-full bg-gray-100 text-gray-500 px-2 py-0.5">{c.porte}</span>}
              <span className="ml-auto text-xs font-medium text-gray-600">{c.total} {c.total === 1 ? "relato" : "relatos"}</span>
            </div>
            <div className="mt-3 h-2 w-full rounded-full bg-gray-200">
              <div
                className="h-2 rounded-full bg-orange-500"
                style={{ width: `${(c.total / max) * 100}%` }}
              />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}
